import { TYPO } from "styles/Typo";
import { useTranslation } from "next-i18next";
import useModalClickOutside from "utils/useModalClickOutside";
import CenterModal from "components/common/Modal/CenterModal";
import useWithdraw from "utils/clientAPIs/withdraw";
import Button from "components/common/buttons/buttons";
import { useRouter } from "next/router";

interface props {
  setModal: (value: boolean) => void;
  setAlarmModal: any;
}
const AlarmLeaveModal = ({ setModal, setAlarmModal }: props) => {
  const modalRef = useModalClickOutside(setModal); // 모달 참조를 위한 ref 추가

  const { t } = useTranslation("detail");
  const router = useRouter();

  return (
    <CenterModal modalRef={modalRef} containerClass="gap-4">
      <h4 className={`${TYPO.TYPO5_SB} text-gray80`}>{t("cancelSetting")}</h4>
      <div className="justify-start items-start gap-2 inline-flex">
        <Button
          text={t("continue")}
          type="tertiary"
          size="xl"
          width="w-full"
          clickHandler={() => {
            setModal(false);
          }}
        />
        <Button
          text={t("cancel")}
          type="primary"
          size="xl"
          width="w-full"
          clickHandler={() => {
            setAlarmModal(false);
            setModal(false);
          }}
        />
      </div>
    </CenterModal>
  );
};

export default AlarmLeaveModal;
